<div class='topbar'>
  <div>
    <h1>Indstillinger for rabatkampagner</h1>
  </div>
  <div class='topbar__actions'>
    @if (canEdit) {
      <button class='btn-icon green' (click)='add()' matTooltip='Opret rabatkampagne'>
        <mat-icon svgIcon='add'></mat-icon>
        <span>Opret rabatkampagne</span>
      </button>
    }
  </div>
</div>
<div class='page__content settings'>
  <div class='settings__wrap'>
    <table mat-table [dataSource]='rabatkampagnerSortedByName' class='mat-elevation-z0 settings__table'>
      <ng-container matColumnDef='name'>
        <th mat-header-cell *matHeaderCellDef>Navn</th>
        <td mat-cell *matCellDef='let row'>
          {{ row.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef='rabat'>
        <th mat-header-cell *matHeaderCellDef>Rabat</th>
        <td mat-cell *matCellDef='let row'>
          {{ getRabatText(row) }}
        </td>
      </ng-container>

      <ng-container matColumnDef='rabatType'>
        <th mat-header-cell *matHeaderCellDef>Rabattype</th>
        <td mat-cell *matCellDef='let row'>
          {{ row.rabatType | rabatType }}
        </td>
      </ng-container>

      <ng-container matColumnDef='partnerShare'>
        <th mat-header-cell *matHeaderCellDef>Fordeling</th>
        <td mat-cell *matCellDef='let row'>
          {{ getPartnerShareText(row) }}
        </td>
      </ng-container>

      <ng-container matColumnDef='actions'>
        <th mat-header-cell class='row-actions' *matHeaderCellDef></th>
        <td mat-cell *matCellDef='let row'>
          <div class='hidden-cell'>
            @if (canEdit) {
              <button (click)='edit(row)' class='btn-icon blue' aria-label='Rediger rabatkampagne'
                matTooltip='Rediger rabatkampagne'
                >
                <mat-icon svgIcon='edit'></mat-icon>
              </button>
            }
            <button (click)="showhistory(row)" class="btn-icon blue" aria-label="Historik" matTooltip="Historik">
              <mat-icon>timeline</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef='displayedColumns; sticky: true'></tr>
      <tr mat-row *matRowDef='let row; columns: displayedColumns'></tr>
    </table>
  </div>
</div>
<app-history-view [historyView]="historyView"></app-history-view>